"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigLoader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _config = require("../../state/entities/config");
var _FullPageLoader = require("../../components/FullPageLoader/FullPageLoader");
var _status = require("../../state/entities/config/status");
var _hooks = require("../../hooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ConfigLoader = props => {
  const {
    silent: isSilent = false,
    children
  } = props;
  const {
    brandId
  } = (0, _hooks.useConfig)();
  const status = (0, _reactRedux.useSelector)(_config.configSelectors.status);
  const errorMessage = (0, _reactRedux.useSelector)(_config.configSelectors.errorMessage);
  const isLoading = [_status.configStatus.SUCCESS, _status.configStatus.ERROR].includes(status);
  const dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(() => {
    dispatch((0, _config.loadConfig)(brandId));
  }, []);
  if (!isLoading) {
    return isSilent ? null : /*#__PURE__*/_react.default.createElement(_FullPageLoader.FullPageLoader, null);
  }
  if (errorMessage) {
    if (isSilent) {
      console.error(errorMessage);
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_core.Box, {
      p: 5
    }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
      variant: "outlined",
      severity: "error"
    }, /*#__PURE__*/_react.default.createElement(_lab.AlertTitle, null, "Error"), errorMessage));
  }
  return children;
};
exports.ConfigLoader = ConfigLoader;